import KnowledgeCenterFAQFeedbackForm from './KnowledgeCenterFAQFeedbackForm';

export default KnowledgeCenterFAQFeedbackForm;
